(ns teamoesterreich.admin-mode.user.user-card-help-lebensretter
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.user :as d-user]
            [teamoesterreich.ajax :as ajax]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.util.log :as log]

            ))



(defn >user-edit-field [user-uuid obj cb-fn]
  (ajax/patch> (str backend/BASE_URL "/user/" user-uuid)
               (ajax/serialize (merge {:user-uuid user-uuid}
                                      obj))
               cb-fn))



(defn check-box [text !actual-user !st key allowEdit?]
  (let [!edited (r/cursor !st [key])
        checked (get @!actual-user key)
        val (if (nil? @!edited) checked @!edited)
        changed? (and (not (nil? @!edited)) (not= @!edited checked))]
    [mui/grid
     {:container false
      :item      true
      :md        6                                          ;medium: 960px
      :xs        12                                         ;extra-small: 0px
      :style     {:backgroundColor (if changed? "#ffd6d2" "#ffffff")}
      }
     [mui/form-control-label {:style     {:backgroundColor (if changed? "#ffd6d2" "#ffffff")}
                              :label     (str text)
                              :disabled  (if allowEdit? false true)
                              :checked   (if val true false)
                              :onChange  (fn [_ b]
                                           (log/debug "edit " text " " (:user-tomId @!actual-user) "->" (not b))
                                           (reset! !edited b))
                              :placement "start"
                              :control   (r/as-element [mui/checkbox {}])}]

     ]))


(defn checkbox-form [!actual-user]
  (let [!st (r/atom {})]
    (fn []
      (let [allowEdit? (d-rights/allow-admin-for d-rights/USER_EDIT (:user-orgId @!actual-user))
            changed? (reduce (fn [c [k v]] (or c (not= v (get @!actual-user k)))) false @!st)
            ]
        [mui/grid
         {:container false
          :item      true
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          }
         [check-box "Lebensretter aktiviert."
          !actual-user
          !st
          :user-helpingLebensretter
          allowEdit?]

         (when changed?
           [mui/card-actions

            [mui/button {
                         :color   "secondary"
                         :variant "contained"
                         :onClick #(reset! !st nil)
                         } "Abbrechen"]
            [mui/button {
                         :color   "primary"
                         :variant "contained"
                         :onClick (fn []
                                    (d-user/>user-edit-field (:user-uuid @!actual-user)
                                                             @!st
                                                             (fn []
                                                               (reset! !st {})
                                                               (d-user/actual-user-invalidate !actual-user)
                                                               )))
                         } "Speichern"]
            ])

         ]
        ))))


(defn action-required-form [!actual-user]
  (let [!st (r/atom {})]
    (fn []
      (let [
            warning-key :user-wanado-warnings-lebensretter-text
            level-key :user-wanado-warnings-lebensretter-level
            warn-text (or (warning-key @!st) (get @!actual-user warning-key) "")
            warn-level (or (level-key @!st) (get @!actual-user level-key) 0)
            allowEdit? (d-rights/allow-admin-for d-rights/USER_EDIT (:user-orgId @!actual-user))
            changed? (reduce (fn [c [k v]] (or c (= v (get @!actual-user k)))) false @!st)
            ]

        [mui/grid
         {:container false
          :item      true
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          }
         [:form
          {:onSubmit (fn [e] (.preventDefault e))}
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "space-between"
            :alignItems "flex-start"
            :spacing    0
            }
           [mui/grid
            {:container false
             :item      true
             :md        4                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             }
            [mui/form-control {:component "fieldset"}
             [mui/radio-group {:row   true
                               :value (str warn-level)
                               }
              [mui/form-control-label
               {:value    "0"
                :disabled true
                :control  (r/as-element [mui/radio {:color "primary"}])
                :label    (str "Kein")
                }
               ]
              [mui/form-control-label
               {:value    "1"
                :disabled true
                :control  (r/as-element [mui/radio {:color "primary"}])
                :label    (str "Info")
                }
               ]
              [mui/form-control-label
               {:value    "2"
                :disabled true
                :control  (r/as-element [mui/radio {:color "primary"}])
                :label    (str "Warn")
                }
               ]]
             ]
            ]
           [mui/grid
            {:container false
             :item      true
             :md        6                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             }
            (when (not= warn-level 0)
              [mui/text-field {:fullWidth    true
                               :disabled     true
                               :defaultValue warn-text
                               }])

            ]

           [mui/grid
            {:container false
             :item      true
             :md        2                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px

             }
            (when changed?
              [mui/card-actions

               [mui/button {
                            :color   "secondary"
                            :variant "contained"
                            :onClick #(reset! !st nil)
                            } "Abbrechen"]
               [mui/button {
                            :color   "primary"
                            :variant "contained"
                            :onClick (fn []
                                       (d-user/>user-edit-field (:user-uuid @!actual-user)
                                                                @!st
                                                                (fn []
                                                                  (reset! !st {})
                                                                  (d-user/actual-user-invalidate !actual-user)
                                                                  )))
                            } "Speichern"]
               ])
            ]
           ]
          ]]

        ))))


(defn get-normal [!actual-user]
  [mui/card {:style {:textAlign "left"}}
   [mui/card-header
    {:title (r/as-element [:span "Lebensretter "
                           [mui/checkbox {:checked  (or (get @!actual-user :user-helpingLebensretter) false)
                                          :color    "primary"
                                          :disabled true
                                          }]])}]
   [mui/card-content
    {
     :style {:padding "20px"}
     }


    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "space-between"
      :alignItems "flex-start"
      :spacing    4
      }


     (when (:user-helpingLebensretterSince @!actual-user)
       [mui/grid
        {:container false
         :item      true
         :md        12                                      ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         }
        [mui/grid
         {:container  true
          :direction  "row"
          :justify    "space-between"
          :alignItems "flex-start"
          :spacing    0
          }
         [mui/grid
          {:container false :item true
           :md        4
           :xs        12
           } [mui/typography {} "Seit "]]
         [mui/grid
          {:container false :item true
           :md        8
           :xs        12
           } [mui/text-field {:fullWidth    true :style {:maxWidth "300px"}
                              :disabled     true
                              :defaultValue (h-date/print-local-date (:user-helpingLebensretterSince @!actual-user))}]]
         ]]
       )

     [mui/grid
      {:container false
       :item      true
       :md        12                                        ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/typography {:variant "h6"} "Aktionen / Hinweise"]]

     [(action-required-form !actual-user)]



     [mui/grid
      {:container false
       :item      true
       :md        12                                        ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/typography {:variant "h6"} "Voraussetzungen"]
      [mui/typography {} "hier kommt einen Erklärung für den Admin rein "]
      ]

     [mui/grid
      {:container false
       :item      true
       :md        12                                        ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [mui/typography {:variant "h6"} "Einstellungen"]
      [mui/typography {} "Folgende Einstellungen zur Lebensretter wurden gesetzt:"]
      ]

     [(checkbox-form !actual-user)]



     [:p ""]
     ]
    ]
   ])

(defn get-linked [!actual-user]
  [mui/card {:style {:textAlign "left"}}
   [mui/card-header
    {:title (r/as-element [:span "Lebensretter "
                           [mui/checkbox {:indeterminate true
                                          :color         "primary"
                                          :disabled      true
                                          }]])}]
   [mui/card-content
    {
     :style {:padding "20px"}
     }


    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "space-between"
      :alignItems "flex-start"
      :spacing    4
      }
     [:p "Account mit Lebensretter verknüpft, Verwaltung extern"]
     ]
    ]
   ]
  )

(defn get-it [!actual-user]
  (if (:user-linkedLebensretter @!actual-user)
    [get-linked !actual-user]
    [get-normal !actual-user]
    ))